<template>
  <div class="log-oppea-box">
    <div class="item">操作用户：{{rowItem.operatedUserPO && rowItem.operatedUserPO.realName}}</div>
    <div class="item">被操作对象：{{form && form.updateTag}}</div>
    <div class="item">修改时间：{{rowItem.operatedTime}}</div>
    <el-row v-if="form">
      <el-col :span="12" v-if="form.beforeStr">
        <div class="grid-content">
          <div class="title">变更前</div>
          <template v-if="form.beforeStr.infoLibraryMap">
            <div class="item">问题：{{form.beforeStr.infoLibraryMap.title}}</div>
          </template>
          <template v-if="form.beforeStr.infoLibraryContentMap">
            <div class="item">回答库：</div>
            <div v-for="(item,index) in form.beforeStr.infoLibraryContentMap" :key="index" class="mt10"><el-tag>{{index+1}}、{{item.content}}</el-tag></div>
          </template>
        </div>
      </el-col>
      <el-col :span="12" v-if="form.afterStr ">
        <div class="grid-content log-line">
          <div class="title">变更后</div>
          <template v-if="form.afterStr.infoLibraryMap">
            <div class="item">问题：{{form.afterStr.infoLibraryMap.title}}</div>
          </template>
          <template v-if="form.afterStr.infoLibraryContentMap">
            <div class="item">回答库：</div>
            <div v-for="(item,index) in form.afterStr.infoLibraryContentMap" :key="index" class="mt10"><el-tag>{{index+1}}、{{item.content}}</el-tag></div>
          </template>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import sysDataCompareLogApi from '@/api/log/sysDataCompareLog'
export default {
  props: ['rowItem'],
  data() {
    return {
      form: null
    }
  },
  created() {
    this.getLogShow()
  },
  methods: {
    getLogShow() {
      sysDataCompareLogApi.fetchById(this.rowItem.id).then(res => {
        this.form = res.data;

      })
    }
  }

}
</script>

<style lang="scss" scoped>
.title-box {
  margin: 10px 24px 15px 0;
  &::after {
    content: '';
    display: table;
    clear: both;
  }
  .txt1 {
    font-size: 16px;
    // font-weight: bold;
    color: #000000;
    position: relative;
    padding-left: 5px;
    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 3px;
      bottom: 0;
      width: 4px;
      background: #5dbde7;
      border-radius: 6px;
    }
  }
  .txt2 {
    font-size: 12px;
    color: #8f8e8e;
    padding-left: 7px;
  }
  .fr {
    float: right;
    font-size: 16px;
    color: #1596cd;
  }
}
</style>
